// LA BARRA FIJA — el estado del dato, siempre a la vista, y las anclas.
//
// Dos cosas viven acá:
//
// 1. LA FRESCURA DEL DATO. Va arriba de todo y se queda pegada al scrollear,
//    porque habilita a todo lo demás: si la PC del estacionamiento dejó de
//    enviar hace seis horas, cada número de la pantalla es una foto vieja
//    presentada como si fuera el presente. En la pantalla actual esto existe,
//    pero es una línea gris de 12px idéntica a cualquier otra cosa: nada
//    distingue "hace 2 minutos" de "hace 14 horas".
//
// 2. LAS ANCLAS. No son pestañas, y la diferencia no es cosmética: una pestaña
//    OCULTA contenido, un ancla lo INDEXA. Con anclas la página se imprime
//    entera, se busca con Ctrl+F y el PDF sale de un documento — las tres cosas
//    que se pidieron y que con pestañas son imposibles.
//
// El `top` es el alto de la barra superior del Monitor ($header-height, 70px en
// _variables.scss). Si esa variable cambia, esto se despega.

import React from "react";
import { UI } from "./theme";
import EstadoDelDato from "./EstadoDelDato";

const ALTO_CABECERA = 70;

const SECCIONES = [
  { id: "hoy", label: "Hoy" },
  { id: "para-mirar", label: "Para mirar" },
  { id: "el-mes", label: "El mes" },
  { id: "para-decidir", label: "Para decidir" },
];

const BarraFija = ({ vivo, cerrados, secciones = SECCIONES, acciones = null }) => {
  const irA = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    // scrollIntoView solo dejaría la sección debajo de la barra fija.
    const y = el.getBoundingClientRect().top + window.pageYOffset - (ALTO_CABECERA + 56);
    window.scrollTo({ top: y, behavior: "smooth" });
  };

  return (
    <div
      className="stats2-barra"
      style={{
        position: "sticky",
        top: ALTO_CABECERA,
        zIndex: 5,
        background: UI.fondo,
        borderBottom: `1px solid ${UI.linea}`,
        margin: "0 -12px 14px",
        padding: "8px 12px",
      }}
    >
      <div className="d-flex align-items-center justify-content-between gap-3 flex-wrap">
        {/* EstadoDelDato decide solo cuánto espacio ocupa: una línea con un
            punto de color cuando el dato está fresco, y un cartel de ancho
            completo cuando la PC dejó de enviar en horario de operación. Por
            eso crece: apretarlo en una esquina anularía justamente el caso que
            importa. */}
        <div style={{ flex: "1 1 auto", minWidth: 0 }}>
          <EstadoDelDato vivo={vivo} cerrados={cerrados} />
        </div>
        {acciones}
      </div>

      {/* Las anclas quedaron sin uso al pasar todo a pestañas, pero el
          componente las sigue soportando: si vuelve a haber secciones largas
          dentro de una pestaña, se le pasan y aparecen. Sin secciones no se
          dibuja el renglón, para no dejar un hueco vacío bajo la barra.
          En el teléfono scrollean en horizontal en vez de apilarse. */}
      {secciones.length > 0 && (
      <div
        className="stats2-anclas"
        style={{
          display: "flex", gap: 6, marginTop: 4,
          overflowX: "auto", scrollbarWidth: "none", WebkitOverflowScrolling: "touch",
        }}
      >
        {secciones.map((s) => (
          <button
            key={s.id}
            type="button"
            onClick={() => irA(s.id)}
            className="btn btn-sm"
            style={{
              fontSize: 12.5, whiteSpace: "nowrap", flexShrink: 0,
              color: UI.textoSuave, background: UI.fondoSuave,
              border: `1px solid ${UI.linea}`, borderRadius: 999, padding: "3px 11px",
            }}
          >
            {s.label}
          </button>
        ))}
      </div>
      )}
    </div>
  );
};

export default BarraFija;
